<template>
  <div class="passWord" v-if="isPassTips">
    <div class="tit">请输入指定密码</div>
    <el-input placeholder="请输入指定密码" type="password" v-model="adminPass" @keyup.enter.native="submitPass"></el-input>
    <el-button @click="cancelPass" v-if="isBackShow">取消</el-button>
    <el-button type="primary" @click="submitPass">确定</el-button>
  </div>
</template>
<script>
export default {
  props:{
    isBackShow:{
      type:Boolean,
      required: true
    }
  },
  data(){
    return{
      isPassTips:true,
      adminPass:'',
    }
  },
  methods:{
    //取消
    cancelPass(){
      this.$router.go(-1)
    },
    //提交
    submitPass(){
      if(this.adminPass == ''){
        this.$message.error('请输入密码！')
        return
      }else if(this.adminPass != 'geekuiot'){
        this.$message.error('请输入正确的密码！')
        return
      }else if(this.adminPass == 'geekuiot'){
        this.isPassTips = false;
      }
    },
  },

}
</script>
<style lang="less">
.passWord{
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  padding: 1.5rem 0;
  box-sizing: border-box;
  text-align: center;
  background: linear-gradient(#297fb8, #2c3e51);
  .tit{
    font-size: 0.4rem;
  }
  .el-input{
    width: 30%;
    font-size: 0.3rem;
    display: block;
    margin: 0.4rem auto;
    .el-input__inner{
      height: 0.6rem;
      line-height: 0.6rem;
    }
  }
  .el-button{
    padding: 0.15rem 1rem;
    font-size: 0.28rem;
    margin: 0 0.35rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/assets/passWord.vue